import React from 'react';
import { Table, Tabs, Text, mergeClassNames, EmptyState } from '@clockout-dev/design-elements';
import moment from 'moment';
import { SupportTicketConstants } from '../support.enums';
import SupportStatusPill from './SupportStatusPill';
import tableStyles from '../../treasury/elements/styles/transactionsTable.module.scss';
import styles from '../styles/supportTicketTable.module.scss';

function SupportTicketTable({
    statusTab,
    onStatusTabChange,
    dataSource,
    loading,
    pagination,
    onChange,
    onRowClick,
}) {
    const statusTabMeta = SupportTicketConstants.LIST_STATUS_TABS.find((t) => t.key === statusTab);

    const pageInfo = pagination
        ? {
            current: pagination.current,
            page: pagination.current,
            perPage: pagination.pageSize,
            total: pagination.total,
        }
        : null;

    const columns = [
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
            ellipsis: true,
            render: (text) => (
                <Text as="span" size="xs" className={styles.subjectCell}>
                    {text}
                </Text>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 160,
            render: (status) => <SupportStatusPill status={status} />,
        },
        {
            title: 'Created',
            key: 'createdat',
            width: 140,
            render: (_, record) => {
                const t = record.createdAt;
                return (
                    <Text as="span" size="xs" className={tableStyles.idCell}>
                        {t ? moment(t).format('MM/DD/YYYY') : '—'}
                    </Text>
                );
            },
        },
        {
            title: 'Unread',
            dataIndex: 'unreadCount',
            key: 'unreadCount',
            width: 90,
            align: 'center',
            render: (n) => (
                n > 0
                    ? <span className={styles.unreadBadge}>{n}</span>
                    : <Text as="span" size="xs" className={tableStyles.idCell}>—</Text>
            ),
        },
    ];

    return (
        <section className={styles.panel}>
            <Tabs
                activeKey={statusTab}
                onChange={onStatusTabChange}
                searchParamKey="status"
                items={SupportTicketConstants.LIST_STATUS_TABS.map(({ key, label }) => ({
                    key,
                    label,
                }))}
            />
            <Table
                rowKey="id"
                dataSource={dataSource}
                loading={loading}
                columns={columns}
                pageInfo={pageInfo}
                saveSearchParams
                onChange={onChange}
                onRow={(record) => ({
                    onClick: () => onRowClick(record),
                })}
                emptyState={<EmptyState title={statusTab === 'all'
                        ? 'No support tickets yet'
                        : `No ${(statusTabMeta?.label || statusTab).toLowerCase()} tickets`} />}
                classNames={{
                    shell: tableStyles.tableWrapper,
                    root: mergeClassNames([tableStyles.table, styles.clickableRows]),
                }}
            />
        </section>
    );
}

export default SupportTicketTable;
